import { isTranslateAbleText, type TranslateAbleText } from './translate-able-text';
import { isNil, isString } from '@pct-ts/typeguard';

export function resolveTranslateAbleText(
  value: TranslateAbleText | null | undefined,
): string | { key: string; params?: unknown } {
  if (isNil(value)) {
    return '';
  }
  if (isTranslateAbleText(value) === false) {
    throw new Error(`[ResolveTranslateAbleTextPipe] Invalid value: ${value}`);
  }

  if (isString(value)) {
    return { key: value, params: undefined };
  }
  if (value?.translate === false) {
    return value.text;
  }

  return { key: value.text, params: value?.translateParams };
}
